export const getOrderDestinationType = (order = {}) => {
  const type = String(order.stakeholderType || order.financeEntityType || '')
    .trim().toLowerCase().replace(/[\s-]+/g, '_');
  if (['outlet', 'customer', 'vendor', 'internal_packing', 'warehouse'].includes(type)) return type;
  if (order.destinationOutletLocation) return 'outlet';
  // Older retail bills may predate stakeholderType. Do not infer a customer
  // destination for dispatches whose destination metadata is unavailable.
  if (order.dispatchOrderId == null && order.posUserName !== 'DISPATCH') return 'customer';
  return '';
};

export const matchesOrderDestinationFilter = (order, destination = '') =>
  !destination || getOrderDestinationType(order) === destination;
